export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12787.90429b1e.jpg";